import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import Layout from "../components/Layout"
import moment from "moment"
import { cgblue } from "../components/colors"
import queryString from "query-string"
import Img from "react-cloudinary-lazy-image"

export const BlogPost = ({ frontmatter, excerpt }) => {
  let coverImageList = frontmatter.coverImageList ? frontmatter.coverImageList 
    : frontmatter.coverImage ?? "https://res.cloudinary.com/controlgap/image/upload/w_800,q_auto,f_auto/blog-images/controlgap-wall.jpg"

  let focalPoint = frontmatter.focalPoint ? `bg-align--${frontmatter.focalPoint}` : ""

  const blogLink = `/blog/${frontmatter.slug}`

  return (
    <div key={frontmatter.slug} className="blog-card">
      <div className="blog-head">
        <div className="tags">
          {frontmatter.tags.map((tag) => (
            <AniLink className="tag" fade to={`/tags/${tag}/`} key={tag}>
              {" "}
              {tag}{" "}
            </AniLink>
          ))}
        </div>
        <h4>
          <AniLink fade to={blogLink}>
            {frontmatter.title}
          </AniLink>
        </h4>
        <span className="date">
          {moment(frontmatter.date).format("DD-MMM-YYYY")}
        </span>
        <p>{excerpt}</p>
        <AniLink className="read-more" fade to={blogLink}>
          {`Read More >`}
        </AniLink>
      </div>
      <AniLink
        className={`blog-image-link blog-image-link--landscape ${focalPoint}`}
        fade
        to={blogLink}
        style={{ backgroundImage: `url(${coverImageList})` }}
      ></AniLink>
    </div>
  )
}

export const BlogList = ({ location, data: { allMarkdownRemark } }) => {
  const { tag = "" } = queryString.parse(location.search)

  const [pageSize, setPageSize] = useState(7)

  const [selectedTags, setSelectedTags] = useState("")

  useEffect(() => {
    setSelectedTags(["events", "insecurity", "blog"].includes(tag) ? tag : "")
  }, [tag])

  const onTagClick = (tag) => (e) => {
    selectedTags.includes(tag) ? setSelectedTags("") : setSelectedTags(tag)
  }

  const onAllTagClick = (e) => {
    setSelectedTags("")
  }

  const handleLoadMore = () => {
    setPageSize(pageSize + 6)
  }

  const allPosts = allMarkdownRemark.edges

  const allTaggedPosts =
    selectedTags === ""
      ? allPosts
      : allPosts.filter((p) =>
          p.node.frontmatter.tags.some((t) => selectedTags.includes(t))
        )

  const postPages = chunk(allTaggedPosts, pageSize)

  const currentPageChunk = postPages[0]
  const hideLoadMoreButton = pageSize >= allTaggedPosts.length

  return (
    <Layout>
      <div className="hero blog-hero hero-text-center">
        <div>
          <h1>Blog</h1>
          <h3>Be in touch with our latest news</h3>
        </div>
      </div>
      <div
        style={{
          background:
            "linear-gradient(103deg, rgb(255, 255, 255) 0%, rgb(205, 205, 205) 100%)",
        }}
      >
        <div className="container">
          <div
            id="blog-controls"
            className="blog-controls"
            style={{ position: "relative" }}
          >
            <div
              id="blogs"
              style={{ position: "absolute", top: "-140px" }}
            ></div>
            <div className="tabs">
              {" "}
              <button
                className={selectedTags === "" ? "active tab" : "tab"}
                onClick={onAllTagClick}
                onKeyDown={onAllTagClick}
              >
                <span>ALL</span>
              </button>
              <button
                className={selectedTags.includes("blog") ? "active tab" : "tab"}
                onClick={onTagClick("blog")}
                onKeyDown={onTagClick("blog")}
              >
                <span>Blog</span>{" "}
              </button>
              <button
                className={
                  selectedTags.includes("insecurity") ? "active tab" : "tab"
                }
                onClick={onTagClick("insecurity")}
                onKeyDown={onTagClick("insecurity")}
              >
                <span>[in]security</span>{" "}
              </button>
              <button
                className={
                  selectedTags.includes("events") ? "active tab" : "tab"
                }
                onClick={onTagClick("events")}
                onKeyDown={onTagClick("events")}
              >
                <span>Events</span>
              </button>
            </div>
          </div>
          <div className="blog-container">
            {currentPageChunk.map((post) => {
              return (
                <BlogPost key={post.node.frontmatter.slug} {...post.node} />
              )
            })}
          </div>
          {hideLoadMoreButton ? null : (
            <button
              className="button-component"
              style={{
                margin: "20px auto",
                background: "transparent",
                color: cgblue,
                borderColor: cgblue,
              }}
              onClick={handleLoadMore}
              onKeyDown={handleLoadMore}
            >
              <span>LOAD MORE</span>
            </button>
          )}
        </div>
        <div>
          <Img
            cloudName={"controlgap"}
            imageName={`cg-website/seesaw.png`}
            fluid={{
              maxWidth: 1286,
              height: 878,
            }}
            alt={"blog security balanced girls on seesaw"}
            style={{
              width: "100%",
              height: "100%",
              maxWidth: "1286px",
              margin: "auto",
            }}
          />
          {/* <img
            src="https://res.cloudinary.com/controlgap/image/upload/v1578337629/q_auto,f_auto/cg-website/seesaw.png"
            alt={"control-gap-blog-security"}
            style={{ width: "100%", maxWidth: "1400px" }}
          /> */}
        </div>
      </div>
    </Layout>
  )
}

function chunk(arr, size) {
  return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
  )
}
export const blogListQuery = graphql`
  query blogListQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            coverImageList
            coverImage
            focalPoint
            title
            date
            slug
            tags
          }
        }
      }
    }
  }
`
export default BlogList
